import React, { createContext, useContext, useState, useEffect } from 'react';

const SubjectContext = createContext();

export function SubjectProvider({ children }) {
  const [subject, setSubjectState] = useState('rw');

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = localStorage.getItem('selectedSubject');
      if (saved && (saved === 'rw' || saved === 'bw')) {
        setSubjectState(saved);
      }
    }
  }, []);

  const setSubject = (newSubject) => {
    setSubjectState(newSubject);
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('selectedSubject', newSubject);
    }
  };

  return (
    <SubjectContext.Provider value={{ subject, setSubject }}>
      {children}
    </SubjectContext.Provider>
  );
}

export function useSubject() {
  const context = useContext(SubjectContext);
  if (!context) {
    throw new Error('useSubject must be used within SubjectProvider');
  }
  return context;
}
